<template>
    <div
        class="mx-auto flex max-w-3xl flex-col items-center gap-x-6 px-4 py-2 sm:justify-center sm:px-6 lg:px-8"
        :class="{
            'hidden sm:flex sm:flex-row': showDiv !== 1,
        }"
    >
        <div class="text-center sm:text-center lg:max-w-7xl">
            <div>
                <h2 class="text-center text-2xl font-bold text-slate-700 sm:text-3xl">
                    In 2 Minuten den passenden Treppenlift finden
                </h2>
            </div>
            <div
                class="mt-4 flex flex-col items-center justify-center sm:mt-8"
                :class="{
                    'hidden ': showDiv !== 1,
                }"
            >
                <img
                    class="inline-block h-20 w-20 rounded-full sm:h-24 sm:w-24"
                    src="/img/home/funnel-man.png"
                    alt=""
                />
            </div>
            <div class="mt-2 max-w-sm text-center sm:mt-10 sm:max-w-xl sm:text-center">
                <p class="mt-4 text-center text-sm text-slate-600 sm:text-lg">
                    Willkommen bei Leben-ohne-Grenzen! <br />
                    Beantworten Sie fragen und erhalte eine kostenlose Erstberatung für Ihren Treppenlift.
                </p>
            </div>
        </div>
    </div>

    <Funnel :eid="eid" @next-step-clicked="handleNextStepClicked" />

    <!-- <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3
            class="mt-6 text-center text-base sm:text-xl font-medium text-slate-800"
        >
            Finden Sie jetzt den perfekten Treppenlift für ihr Zuhause. Leben-ohne-Grenzen
            hilft Ihnen dabei!
        </h3>
        <div
            class="grid grid-cols-2 max-w-2xl mx-auto gap-2 py-4 place-items-center"
        >
            <div
                v-for="pro in pros"
                class="inline-flex items-center gap-2 text-sm justify-center sm:justify-start"
            >
                <CheckCircleIcon class="h-5 text-lime-600" /><span>
                    {{ pro }}
                </span>
            </div>
        </div>
    </div> -->

    <CTASection />
    <!-- <FunnelFAQSection :faqs="faqs" /> -->
</template>

<script setup>
import { ref } from 'vue'
import Funnel from '@/Components/Stairlift/Funnel.vue'
import CTASection from '@/Components/Sections/CTASection.vue'
import FunnelLayout from '@/Layouts/FunnelLayout.vue'

defineProps({
    eid: String,
})

defineOptions({
    layout: FunnelLayout,
})

let showDiv = ref(1)

const handleNextStepClicked = (arrayLength) => {
    console.log('arraylength: ', arrayLength)
    showDiv.value = arrayLength
}
</script>
